import { defaultTheme } from '@yes.technology/react-toolkit'

export const SELECT_AND_LINK_PARAM = 'select_and_link'

export const SELECT_AND_LINK_POST_MESSAGE_TYPE = 'select_and_link'

export const CANCEL_SELECT_AND_LINK_POST_MESSAGE_TYPE = 'cancel_select_and_link'

export const OPEN_SELECT_AND_LINK_POST_MESSAGE_TYPE = 'open_select_and_link'

export const SELECT_AND_LINK_NESTED_RESULT_POST_MESSAGE_TYPE =
  'select_and_link_nested_result'

export const CANCEL_SELECT_AND_LINK_NESTED_POST_MESSAGE_TYPE =
  'cancel_select_and_link_nested'

export const SELECT_AND_LINK_SESSION_STORAGE_KEY = 'selectAndLinkSession'

export const MODAL_DEFAULT_ZINDEX = defaultTheme.zIndexes.modal

export enum targetComponents {
  FILTER_FIELDS = 'FilterFields',
  OBJECT_VIEW = 'ObjectView'
}

export const DEFAULT_FILTER_FIELDS_SESSION_ID = targetComponents.FILTER_FIELDS
